module.exports = __webpack_public_path__ + "img/widi-yourvoice-gradient.d06fc6fa.png";